<template>
    <rkm-modal
        :buttons="['cancel']"
        title="FAA"
        ref="Modal"
    >
        <rkm-alert class="mb-3">
            <span>
                <strong>Paciente:</strong> {{ nomePaciente }}
            </span>
        </rkm-alert>

        <List
            @select="handleSelect"
            :faas="faas"
        />
    </rkm-modal>
</template>

<script>
import List from './List'

export default {
    components: { List },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleSelect(faaId) {

            this.$emit('select', faaId)

            this.$refs.Modal.hide()
        },
    },
    props: {
        faas: { type: Array, required: true },
        nomePaciente: { type: String, required: true }
    }
}
</script>